(function () {
  'use strict';
  var $window = $(window);

  var checkSectionBottomPosition = function () {
    var sectionBottomEl = $('.section-bottom')[0];

    if (!sectionBottomEl) return;

    var windowScrollY = window.scrollY || window.pageYOffset || document.documentElement.scrollTop;

    if (sectionBottomEl.offsetTop + sectionBottomEl.clientHeight < window.innerHeight + windowScrollY) {
      $(sectionBottomEl).addClass('active');
    }
  };

  var scrollListener = {
    header: document.querySelector('.section-header'),
    settings: {
      stickyAfter: document.querySelector('.section-top-bar').offsetHeight,
      stickyClassName: 'sticky'
    },
    scroll: function () {
      if (!this.header) {
        return;
      }
      var classList = this.header.classList;
      var windowScrollY = window.scrollY || window.pageYOffset || document.documentElement.scrollTop;

      checkSectionBottomPosition();

      // This condition prevents jumping on pages with small height
      if (document.body.clientHeight - window.innerHeight < 128) {
        if (windowScrollY < this.settings.stickyAfter) {
          classList.remove(this.settings.stickyClassName);
        }
        return;
      }


      if ($window.outerWidth() > 991) {
        if (windowScrollY > this.settings.stickyAfter) {
          classList.add(this.settings.stickyClassName);
        } else {
          classList.remove(this.settings.stickyClassName);
        }
      }


    },
    resize: function () {
      var windowScrollY = window.scrollY || window.pageYOffset || document.documentElement.scrollTop;

      if ($window.outerWidth() < 992) {
        this.header.classList.remove(this.settings.stickyClassName);
      } else if (windowScrollY > this.settings.stickyAfter) {
        this.header.classList.add(this.settings.stickyClassName);
      }
    }
  }

  $window.resize(scrollListener.resize.bind(scrollListener));
  $window.scroll(scrollListener.scroll.bind(scrollListener));
  $window.bind("DOMSubtreeModified", checkSectionBottomPosition);
}());